module.exports = __webpack_public_path__ + "media/images/socials/github-b8ab7590162bfc9073c5728c019ddef6.png";